<template>
  <div>
    <el-dialog
      title="增减库存"
      width="40%"
      :visible.sync="isShowInventory"
      destroy-on-close
      :before-close="close"
    >
      <el-form
        ref="formRef"
        :model="inventoryForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="操作:" required>
          <el-radio-group v-model="inventoryForm.type" @change="handleSelect">
            <el-radio :label="0">增加库存</el-radio>
            <el-radio :label="1">减少库存</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="实物名称:">
          <span>{{ editForm.goodsName }}</span>
        </el-form-item>
        <el-form-item label="当前剩余库存:">
          <span
            >{{ editForm.remanentAmount ? editForm.remanentAmount : 0 }}件</span
          >
        </el-form-item>
        <el-form-item
          label="增加库存量:"
          v-if="inventoryForm.type == 0"
          prop="amount"
        >
          <el-input
            placeholder="请输入"
            v-model.number="inventoryForm.amount"
            style="width: 120px"
          ></el-input>
          <span style="margin-left: 8px;">件</span>
        </el-form-item>
        <el-form-item label="追加后剩余库存:" v-if="inventoryForm.type == 0">
          <span>{{ addstockTotal }}件</span>
        </el-form-item>
        <template v-else-if="inventoryForm.type == 1">
          <el-form-item label="可减少库存:">
            <span>{{ editForm.budgetRemain }}</span>
            <span style="margin-left: 8px">件</span>
            <el-tooltip
              class="item"
              effect="light"
              content="可减少库存为：总库存-活动占用库存"
              placement="top-start"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="减少库存量:" prop="amount">
            <el-input
              placeholder="请输入"
              v-model.number="inventoryForm.amount"
              style="width: 120px"
            ></el-input>
            <span style="margin-left: 8px">件</span>
          </el-form-item>
          <el-form-item label="扣减后剩余库存:">
            <span>{{ reduceStockTotal }}件</span>
          </el-form-item>
        </template>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="handleStockConfirm('formRef')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { updateInventory } from "@/api/integralCenter/physical.js";
export default {
  components: {},
  props: {
    isShowInventory: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rules: {
        amount: [
          {
            required: true,
            message: "请输入增加库存量",
            trigger: "change",
          },
        ],
      },
      inventoryForm: {
        type: 0,
        amount: "",
      },
    };
  },
  computed: {
    addstockTotal() {
      return (
        Number(this.inventoryForm.amount ? this.inventoryForm.amount : 0) +
        Number(this.editForm.remanentAmount ? this.editForm.remanentAmount : 0)
      );
    },
    reduceStockTotal() {
      return (
        Number(this.editForm.remanentAmount) - Number(this.inventoryForm.amount)
      );
    },
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.inventoryForm.id = this.editForm.id;
      this.inventoryForm.goodsName = this.editForm.goodsName;
    },
    handleSelect(val) {
      if (val == 1) {
        this.rules.amount = [
          {
            required: true,
            message: "请输入减少库存量",
            trigger: "change",
          },
        ];
      } else {
        this.rules.amount = [
          {
            required: true,
            message: "请输入增加库存量",
            trigger: "change",
          },
        ];
      }
      this.inventoryForm.amount = "";
    },
    close() {
      this.$emit("close");
    },
    handleStockConfirm(formRef) {
      this.$refs[formRef].validate(async (valid) => {
        if (valid) {
          const res = await updateInventory(this.inventoryForm);
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.$emit("close", true);
          } else {
            this.$message.error(res.message);
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="" scoped></style>
